<upp-visible-control mode="content">
    <ng-container *ngIf="item !== null">
        <upp-thumb uppTouch [uppDataid]="'offerthumb-' + (tr(item.name) || '') + '-thumb'"
            [card]="item.photo"
            [title]="tr(item.name)" 
            (TouchClick)="OnSelect()"
        ></upp-thumb>

        <ion-icon *ngIf="item.IsOffer" class="floating top left dark" name="flower-outline"></ion-icon>
        <ion-icon *ngIf="item.IsMenu" class="floating top left dark" name="fast-food-outline"></ion-icon>
        <ion-icon *ngIf="item.IsDiscount" class="floating top left dark" name="heart-outline"></ion-icon>
    </ng-container>

    <ng-container *ngIf="item === null">
        <upp-thumb uppDataid="offerthumb-create-button" 
            icon="add-outline" 
            [title]="tr('@place_offer_create')" 
            (click)="OnSelect()"
        ></upp-thumb>        
    </ng-container>        
</upp-visible-control>

